export const ENTITY_PERSON = "Person";
export const ENTITY_COMPANY = "company";
